// extracted by mini-css-extract-plugin
export var watermark = "WatermarkOne-module--watermark--g7eIv";
export var watermarkContainer = "WatermarkOne-module--watermarkContainer--VxllQ";